import { z } from 'zod';

import { InterestOnEscrowDepositHistoryItemInput } from '../loan/InterestOnEscrowDepositHistoryItem';
import { Payment } from '../loan/Payments';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateDepositEvent = BaseLoanEvent.extend({
  type: z.literal('createDeposit'),
  deposit: Payment,
  comment: z.string().optional(),
  interestOnEscrowDepositHistoryItem: InterestOnEscrowDepositHistoryItemInput.optional(),
});
export type CreateDepositEvent = z.infer<typeof CreateDepositEvent>;
